import { render, staticRenderFns } from "./WebboxUpdateNotice.vue?vue&type=template&id=1fac493e"
import script from "./WebboxUpdateNotice.vue?vue&type=script&lang=js"
export * from "./WebboxUpdateNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports